



































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Smokeleaf from "../../../store/entities/smokeleaf";
class PagefactoryRequest{
  cId:Number;
  ftId:Number;
  wId:Number;
  fId:Number;
}
@Component
export default class CreatSmokeleafs extends AbpBase {
  pagefactoryrequest: PagefactoryRequest = new PagefactoryRequest();
  @Prop({ type: Boolean, default: false }) value: boolean;
  smokeleaf: Smokeleaf = new Smokeleaf();
  idisable:boolean = false;
  selwarehouselist = [];
  selfloorlist = [];
  selsmokecriblist=[];
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  get factory(){
    return this.$store.state.factory.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.filterlist;
  }
   get floor() {
    return this.$store.state.floor.filterlist;
  }
  save() {
      
    (this.$refs.smokeleafForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if(this.smokeleaf["comeTime"] == ""){
          this.smokeleaf["comeTime"] = "0001/1/1 0:00:00";
        }
        if(this.smokeleaf["outTime"] == ""){
          this.smokeleaf["outTime"] = "0001/1/1 0:00:00";
        }
        if(this.smokeleaf["allamount"] == null){
          this.smokeleaf["allamount"] = 0;
        }
        if(this.smokeleaf["weight"] == null){
          this.smokeleaf["weight"] = 0;
        }
        if(this.smokeleaf["samount"] == null){
          this.smokeleaf["samount"] = 0;
        }
        this.idisable = true;
        await this.$store.dispatch({
          type: "smokeleaf/create",
          data: this.smokeleaf,
        });
        (this.$refs.smokeleafForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
         setTimeout(()=>{
           this.idisable=false   //点击一次时隔两秒后才能再次点击
       },2000)
      }
    });
  }
  cancel() {
    (this.$refs.smokeleafForm as any).resetFields();
    this.$emit("input", false);
     this.selwarehouselist = [];
    this.selfloorlist = [];
  }
  smokeleafRule = {
    ftId: [{type:"number",required: true, message: "请选择库区", trigger: "change" }],
    wId: [{type:"number",required: true, message: "请选择库房", trigger: "change" }],
    fId: [{type:"number",required: true, message: "请选择楼层", trigger: "change" }],
    //sId: [{ type:"number",required: true, message: "请选择烟垛", trigger: "change" }],
  };
  selfactory(value:Number){
    this.pagefactoryrequest.ftId = value;
    if(value !=0 && value != undefined){
      this.getselwarehouse();
    }
  }
  selwarehouse(value:Number){
    this.pagefactoryrequest.wId = value;
  if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.smokeleaf.fId = 0;
      this.selfloorlist = [];
    }
  }
  async getsmokecrib() {
    //烟叶
    //filters
    this.selsmokecriblist=await this.$store.dispatch({
      type: "smokecrib/getsel",
       data: this.smokeleaf,
    });
  }
  get smokecrib() {
    return this.$store.state.smokecrib.filterlist;
  }
   selfloor(value:Number){
    this.pagefactoryrequest.fId = value;
      this.getsmokecrib();
    
  }
    async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagefactoryrequest,
    });
  }
   async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagefactoryrequest,
    });
  }
}
